export default {
  "b2b.zdroje-typy-grid.label": "Types of resources"
};
